export const providerAliasMap = {
  "Hemas": ["arogya"],
  "Firstdoctor": ["First Doctor"]
};

export const getProviderDisplayName = (providerName) => {
  if (!providerName) return "";

  const normalized = providerName.trim().toLowerCase();
  
  for (const [displayName, aliases] of Object.entries(providerAliasMap)) {
    if (aliases.some(alias => alias.toLowerCase() === normalized)) {
      return displayName;
    }
  }
  return providerName;
};